var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 20,
    viewBox: "0 0 101 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5625 19.2876H19.0245V0.84375H0.5625V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3026 8.69083L5.8312 16.2902L7.35918 11.5935L3.35938 8.69083H8.30334L9.83101 3.99382L11.3587 8.69083H16.3026ZM9.83139 13.3878L12.6912 12.7869L13.8306 16.2902L9.83139 13.3878Z",
    fill: "#FDFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.9648 19.2876H39.4269V0.84375H20.9648V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.9648 19.2876H30.1959V0.84375H20.9648V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.4164 13.3161L32.8687 12.7867L34.0029 16.3696L30.1572 13.5022L26.1615 16.3696L27.7123 11.6558L23.6523 8.7426H28.6706L30.2208 4.02853L31.7716 8.7426H36.7896L30.4164 13.3161Z",
    fill: "#FDFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.3789 19.2876H59.8409V0.84375H41.3789V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.3789 19.2876H50.6099V0.84375H41.3789V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.1191 8.69083L46.6476 16.2902L48.1756 11.5935L44.1758 8.69083H49.1197L50.6474 3.99382L52.1751 8.69083L57.1191 8.69083ZM50.6478 13.3878L53.5076 12.7869L54.647 16.2902L50.6478 13.3878Z",
    fill: "#FDFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M61.7969 19.2876H80.2589V0.84375H61.7969V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M61.7969 19.2876H71.0279V0.84375H61.7969V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M77.5331 8.69083L67.062 16.2902L68.5897 11.5935L64.5898 8.69083H69.5338L71.0615 3.99382L72.5891 8.69083L77.5331 8.69083ZM71.0619 13.3878L73.9216 12.7869L75.061 16.2902L71.0619 13.3878Z",
    fill: "#FDFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M82.1992 19.2876H100.661V0.84375H82.1992V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M82.1992 19.2876H91.4302V0.84375H82.1992V19.2876Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M97.9355 8.69083L87.4643 16.2902L88.992 11.5935L84.9922 8.69083H89.9361L91.4638 3.99382L92.9915 8.69083H97.9355ZM91.4642 13.3878L94.324 12.7869L95.4634 16.2902L91.4642 13.3878Z",
    fill: "#FDFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.1ef5f03b8f76806cb6b8be1c7fb423b9.svg";
export { ForwardRef as ReactComponent };